import { Button, CssBaseline, Dialog, Grid, NativeSelect, TextField, Typography } from "@material-ui/core";
import MaterialTable from "material-table";
import LabelsContext from "../../../lang/LabelsContext";
import { tableIcons } from "../../system/material-table-utils/MaterialTableUtils";
import useStyles from "./AllReviewersStyle";
import AddReviewer from "../add-reviewer/AddReviewer";
import { DialogActions, DialogContent } from "@material-ui/core";
import AllReviewersService, { AllReviewersServiceType } from "./AllReviewersService";
import EnumSeniority from "../../../utils/enum/EnumSeniority";

export default function AllReviewers() {
  const { Labels } = LabelsContext();
  const classes = useStyles();
  const {
    reviewerEdit,
    setReviewerEdit,
    reviewerList,
    updateExpertise,
    openDialog,
    handleOpenDialog,
    handleCloseDialog,
    saveReviewer,
    updateSeniority,
  }: AllReviewersServiceType = AllReviewersService();

  return (
    <>
      <CssBaseline />
      <MaterialTable
        data={reviewerList}
        icons={tableIcons}
        columns={[
          { field: "id", title: "ID", hidden: true },
          { field: "firstName", title: Labels.FIRSTNAME },
          { field: "lastName", title: Labels.LASTNAME },
          { field: "orcid", title: Labels.ORCID },
          { field: "country", title: Labels.COUNTRY },
          { field: "institute", title: Labels.INSTITUTE },
          {
            field: "areasOfExpertise",
            title: Labels.AREAS_OF_EXPERTISE,
            cellStyle: { width: "60%" },
          },
          {
            field: "seniority",
            sorting: true,
            title: Labels.SENIORITY,
            render: (rowData) => (
              <NativeSelect
                color="primary"
                value={rowData?.seniority?.level}
                className={classes.selectSeniority}
                onChange={(e) => {
                  updateSeniority(rowData.id, e.target.value);
                }}
              >
                <option selected={rowData.seniority?.level === EnumSeniority.JUNIOR} value={EnumSeniority.JUNIOR}>
                  {Labels.JUNIOR}
                </option>
                <option selected={rowData.seniority?.level === EnumSeniority.MEDIOR} value={EnumSeniority.MEDIOR}>
                  {Labels.MEDIOR}
                </option>
                <option
                  selected={!rowData.seniority || rowData.seniority?.level === EnumSeniority.SENIOR}
                  value={EnumSeniority.SENIOR}
                >
                  {Labels.SENIOR}
                </option>
              </NativeSelect>
            ),
          },
          {
            field: "edit",
            sorting: false,
            title: "",
            align: "right",
            render: (rowData) => (
              <Button
                variant="contained"
                onClick={() => {
                  setReviewerEdit(rowData);
                  handleOpenDialog();
                }}
                color="primary"
              >
                {Labels.UPDATE}
              </Button>
            ),
          },
        ]}
        title={
          <div className={classes.addReviewerContainer}>
            <Typography variant="h5">
              {Labels.ALL_REVIEWERS} - {Labels.UPDATE_AREAS_OF_EXPERTISE}
            </Typography>
            <AddReviewer save={saveReviewer} label={Labels.ADD_REVIEWER} />
          </div>
        }
        options={{
          sorting: true,
          actionsColumnIndex: -1,
          pageSize: 10,
          pageSizeOptions: [10, 50, 100, reviewerList?.length > 100 ? reviewerList.length : 1000],
        }}
      />
      <Dialog
        maxWidth={"md"}
        fullWidth={true}
        open={openDialog}
        onClose={handleCloseDialog}
        aria-labelledby="form-dialog-title"
      >
        {reviewerEdit && (
          <DialogContent>
            <Grid container spacing={3}>
              <Typography variant="h6">
                {`${Labels.REVIEWER}: ${reviewerEdit.firstName} ${reviewerEdit.lastName} - ${reviewerEdit.orcid}`}
              </Typography>
              <TextField
                variant="outlined"
                margin="normal"
                id="areasOfExpertise"
                name="areasOfExpertise"
                label={Labels.AREAS_OF_EXPERTISE}
                value={reviewerEdit.areasOfExpertise}
                onChange={(e: any) => setReviewerEdit({ ...reviewerEdit, areasOfExpertise: e.target.value })}
                fullWidth
                multiline
                rows={5}
              />
            </Grid>
          </DialogContent>
        )}
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
            {Labels.CANCEL}
          </Button>
          <Button variant="contained" color="primary" onClick={() => updateExpertise(reviewerEdit)}>
            {Labels.SAVE}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
